import dayjs from 'dayjs';

const formatDay = (value) => (value ? dayjs(value).format('MM/DD/YY') : '');

export const buildUnmatchReferenceId = (bac) => {
  const bacToken = bac
    ? String(bac).toUpperCase().replace(/[^A-Z0-9]/g, '').slice(-4).padStart(4, 'X')
    : 'XXXX';
  const timeToken = Date.now().toString(36).toUpperCase().slice(-8);
  const randomToken = Math.random().toString(36).slice(2, 5).toUpperCase();
  return `UNM${bacToken}${timeToken}${randomToken}`;
};

export const resolvePopcornParentPricePatch = (productCd) => {
  const normalized = String(productCd || '').trim().toUpperCase();
  if (!normalized) return null;
  // Important: DI_P1_ must be checked before DI_P_ since it is a prefix match.
  if (normalized.startsWith('DI_B_')) {
    return { dealerPrice: '1549', filler: '1364' };
  }
  if (normalized.startsWith('DI_P1_')) {
    return { dealerPrice: '2249', filler: '1980' };
  }
  if (normalized.startsWith('DI_P_')) {
    return { dealerPrice: '3349', filler: '2948' };
  }
  return null;
};

export const resolveSecondaryPricingPatch = (productCd) => {
  const normalized = String(productCd || '').trim().toUpperCase();
  if (!normalized) return null;
  // Important: DI_P1_ must be checked before DI_P_ since it is a prefix match.
  if (normalized.startsWith('DI_B_')) {
    return { dealerPrice: '1239', filler: '1091' };
  }
  if (normalized.startsWith('DI_P1_')) {
    return { dealerPrice: '1799', filler: '1584' };
  }
  if (normalized.startsWith('DI_P_')) {
    return { dealerPrice: '2679', filler: '2358' };
  }
  return null;
};

export const buildQuickActionPatch = (actionKey, options = {}) => {
  const now = dayjs();
  const past = formatDay(now.subtract(60, 'day'));
  const future = formatDay(now.add(365, 'day'));
  const productCd = options.productCd;

  switch (actionKey) {
    case 'forceLive':
      return { billingDate: past, selectionDate: past, effectiveDate: past, status: 'Live' };
    case 'forceCancelled':
      return { billingDate: past, selectionDate: past, effectiveDate: past, status: 'Cancelled' };
    case 'forcePendingLive':
      return { billingDate: future, selectionDate: future, effectiveDate: future, status: 'Pending Live' };
    case 'forcePendingCancel':
      return { billingDate: future, selectionDate: future, effectiveDate: future, status: 'Pending Cancel' };
    case 'forceSecondaryPricing': {
      const patch = resolveSecondaryPricingPatch(productCd);
      return patch || null;
    }
    case 'forcePopcornParentLive': {
      const patch = {
        billingDate: past,
        selectionDate: past,
        effectiveDate: past,
        status: 'Live',
        referenceId: '',
        ...(resolvePopcornParentPricePatch(productCd) || {}),
      };
      if (options.referenceId !== undefined) {
        patch.referenceId = String(options.referenceId || '').trim();
      }
      return patch;
    }
    case 'cancelAndUnmatch': {
      return {
        billingDate: past,
        selectionDate: past,
        effectiveDate: past,
        status: 'Cancelled',
        referenceId: buildUnmatchReferenceId(options.bac),
      };
    }
    case 'setDates': {
      const dateValue = options.dateValue;
      if (!dateValue || !dateValue.isValid || !dateValue.isValid()) return null;
      const formatted = formatDay(dateValue);
      return { billingDate: formatted, selectionDate: formatted, effectiveDate: formatted };
    }
    default:
      return null;
  }
};
